import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconHomeSolid } from '@flixbus/honeycomb-icons-react';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/panel.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import '../../../packages/props-utils/prop-types.js';
import { usePanelContext } from '../panel-context.js';
import Button from '../../button/button.js';
import Heading from '../../heading/heading.js';

const bemPanel = new HoneyBem('panel', styles);
function PanelHeader(_a) {
  var {
      children,
      backButtonProps,
      closeButtonProps,
      extraClasses
    } = _a,
    rest = __rest(_a, ["children", "backButtonProps", "closeButtonProps", "extraClasses"]);
  const backButtonRef = React.useRef(null);
  const closeButtonRef = React.useRef(null);
  const {
    titleId
  } = usePanelContext();
  const _b = Object.assign({}, backButtonProps),
    {
      label: backLabel,
      InlineIcon: backIcon
    } = _b,
    backRest = __rest(_b, ["label", "InlineIcon"]);
  const _c = Object.assign({}, closeButtonProps),
    {
      label: closeLabel
    } = _c,
    closeRest = __rest(_c, ["label"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, rest, {
    className: bemPanel.e('header', {}, extraClasses)
  }), backButtonProps && (/*#__PURE__*/React.createElement(Button, Object.assign({
    innerRef: backButtonRef,
    appearance: "link",
    display: "square",
    size: "md",
    extraClasses: bemPanel.e('back'),
    "aria-label": backLabel
  }, backRest), /*#__PURE__*/React.createElement(Icon, {
    InlineIcon: backIcon || IconHomeSolid,
    "aria-hidden": "true"
  }))), /*#__PURE__*/React.createElement("div", {
    id: titleId,
    className: bemPanel.e('title')
  }, typeof children === 'string' ? /*#__PURE__*/React.createElement(Heading, {
    flushSpace: true,
    size: 3
  }, children) : children), closeButtonProps && (/*#__PURE__*/React.createElement(Button, Object.assign({
    innerRef: closeButtonRef,
    appearance: "link",
    display: "square",
    size: "md",
    extraClasses: bemPanel.e('close'),
    "aria-label": closeLabel
  }, closeRest))));
}
PanelHeader.displayName = 'PanelHeader';
PanelHeader.propTypes = {
  extraClasses: PropTypes.string,
  children: PropTypes.node.isRequired,
  backButtonProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    InlineIcon: PropTypes.func
  }),
  closeButtonProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  })
};

export { PanelHeader as default };
